import { render, staticRenderFns } from "./TPSolar.vue?vue&type=template&id=4d84e9f6&"
import script from "./TPSolar.vue?vue&type=script&lang=js&"
export * from "./TPSolar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports